"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTimeRangeSelectorNeoDark = exports.dateTimeRangeSelectorNeoLight = exports.dateTimeRangeSelectorNovoDark = exports.dateTimeRangeSelectorNovo = exports.dateTimeRangeSelector = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const dateTimeSelector_const_1 = require("./dateTimeSelector.const");
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const dateTimeRangeSelector = {
    ...dateTimeSelector_const_1.dateTimeSelector,
    // Input Box
    width: '380px',
    // Dropdown container
    containerPadding: undefined,
    // Dropdown contents
    calendarHorizontalMargin: spacing_const_1.default.lg,
    calendarBottomMargin: spacing_const_1.default.xxl,
    dateTimeInputsPadding: spacing_const_1.default.sm,
    dateTimeInputsMarginBottom: spacing_const_1.default.sm,
    dateTimeInputsBorderSize: size_const_1.default.borderSizeDefault,
    dateTimeInputsBorderColor: color_const_1.default.cloudyBlue300,
    dateInputMarginRight: spacing_const_1.default.sm,
    timeInputMarginRight: spacing_const_1.default.sm,
    timeInputContainerMarginLeft: spacing_const_1.default.md,
    endTimeErrorColor: color_const_1.default.coral,
    endTimeErrorLineHeight: font_const_1.default.lineHeightXs,
    endTimeErrorFontSize: font_const_1.default.sizeXs,
    // Predefined List
    listBackgroundColor: color_const_1.default.cloudyBlue100,
    listBorderRightColor: color_const_1.default.cloudyBlue300,
    listBorderRightSize: size_const_1.default.borderSizeDefault,
    listWidth: '140px',
    listItemFontSize: font_const_1.default.sizeXs,
    listItemLineHeight: font_const_1.default.lineHeightXs,
    listItemPaddingVertical: spacing_const_1.default.xs,
    listItemPaddingHorizontal: `${parseInt(spacing_const_1.default.sm, 10) - 2 * parseInt(size_const_1.default.borderSizeDefault, 10)}px`,
    listItemColor: color_const_1.default.pickledBluewood800,
    listItemSelectedColor: color_const_1.default.dodgerBlue,
    listItemSelectedWidth: size_const_1.default.small,
    listInputMarginTop: `-${parseInt(spacing_const_1.default.xs, 10) - parseInt(size_const_1.default.borderSizeDefault, 10)}px`,
    listInputMarginBottom: `-${parseInt(spacing_const_1.default.xs, 10) - 2 * parseInt(size_const_1.default.borderSizeDefault, 10)}px`,
    listInputMarginLeft: spacing_const_1.default.xxs,
    listInputMarginRight: `${parseInt(spacing_const_1.default.xxs, 10) - parseInt(size_const_1.default.borderSizeDefault, 10)}px`,
    listInputHorizontalSpacing: spacing_const_1.default.xxs,
    listInputMinWidth: 0,
    listInputWidth: '28px',
    listInputVerticalSpacing: 0,
};
exports.dateTimeRangeSelector = dateTimeRangeSelector;
const commonProps = {
    // Input Box
    width: '380px',
    // Dropdown container
    containerPadding: undefined,
    // Dropdown contents
    calendarHorizontalMargin: light.spacing06,
    calendarBottomMargin: light.spacing08,
    dateTimeInputsPadding: light.spacing04,
    dateTimeInputsMarginBottom: light.spacing04,
    dateTimeInputsBorderSize: '1px',
    dateInputMarginRight: light.spacing04,
    timeInputMarginRight: light.spacing04,
    timeInputContainerMarginLeft: light.spacing05,
    endTimeErrorFontSize: light.label01.fontSize,
    endTimeErrorLineHeight: light.label01.lineHeight,
    // Predefined List
    listBorderRightSize: '1px',
    listWidth: '140px',
    listItemFontSize: light.label01.fontSize,
    listItemLineHeight: light.label01.lineHeight,
    listItemPaddingVertical: light.spacing03,
    listItemPaddingHorizontal: `${parseInt(light.spacing04, 10) - 2 * parseInt('1px', 10)}px`,
    listItemSelectedWidth: '4px',
    listInputMarginTop: `-${parseInt(light.spacing03, 10) - parseInt('1px', 10)}px`,
    listInputMarginBottom: `-${parseInt(light.spacing03, 10) - 2 * parseInt('1px', 10)}px`,
    listInputMarginLeft: light.spacing02,
    listInputMarginRight: `${parseInt(light.spacing02, 10) - parseInt('1px', 10)}px`,
    listInputHorizontalSpacing: light.spacing02,
    listInputMinWidth: 0,
    listInputWidth: '28px',
    listInputVerticalSpacing: 0,
};
const dateTimeRangeSelectorNovo = {
    ...dateTimeSelector_const_1.dateTimeSelectorNovo,
    ...commonProps,
    dateTimeInputsBorderColor: light.ui01,
    endTimeErrorColor: light.action03,
    listBackgroundColor: light.ui05,
    listBorderRightColor: light.ui01,
    listItemColor: light.textColor01,
    listItemSelectedColor: light.focus01,
};
exports.dateTimeRangeSelectorNovo = dateTimeRangeSelectorNovo;
const dateTimeRangeSelectorNovoDark = {
    ...dateTimeSelector_const_1.dateTimeSelectorNovoDark,
    ...commonProps,
    dateTimeInputsBorderColor: dark.ui01,
    endTimeErrorColor: dark.action03,
    listBackgroundColor: dark.ui05,
    listBorderRightColor: dark.ui01,
    listItemColor: dark.textColor01,
    listItemSelectedColor: dark.focus01,
};
exports.dateTimeRangeSelectorNovoDark = dateTimeRangeSelectorNovoDark;
const dateTimeRangeSelectorNeoLight = {
    ...dateTimeSelector_const_1.dateTimeSelectorNeoLight,
    ...commonProps,
    dateTimeInputsBorderColor: neoLight.ui01,
    endTimeErrorColor: neoLight.action03,
    // Predefined List
    listBorderRightSize: '1px',
    listWidth: '140px',
    listItemFontSize: neoLight.label01.fontSize,
    listItemLineHeight: neoLight.label01.lineHeight,
    listBackgroundColor: neoLight.ui05,
    listBorderRightColor: neoLight.ui01,
    listItemColor: neoLight.textColor01,
    listItemSelectedColor: neoLight.focus01,
};
exports.dateTimeRangeSelectorNeoLight = dateTimeRangeSelectorNeoLight;
const dateTimeRangeSelectorNeoDark = {
    ...dateTimeSelector_const_1.dateTimeSelectorNeoDark,
    ...commonProps,
    dateTimeInputsBorderColor: neoDark.ui01,
    endTimeErrorColor: neoDark.action03,
    listBackgroundColor: neoDark.ui05,
    listBorderRightColor: neoDark.ui01,
    listItemColor: neoDark.textColor01,
    listItemSelectedColor: neoDark.focus01,
};
exports.dateTimeRangeSelectorNeoDark = dateTimeRangeSelectorNeoDark;
